/**
 * Application-level error handler
 * @param {Error} error - The error to capture
 * @param {Object} options - Optional Sentry capture options (extra, tags, etc.)
 */
export const errorHandler = (error, options = {}) => {
	// If Sentry is not available, log the error to the console
	if (window.Sentry === undefined) {
		console.error(error);

		return;
	}

	Sentry.captureException(error, options);
};
